import { Alexander, Alina, Arogundade, Hasmik, Herbert, Maryna, MarynaAltun, Timo } from 'shared/assets/images/team';

type TeamMember = {
  id: number;
  image: string;
  name: string;
  link: string;
  align: 'left' | 'right' | 'none';
};

export const team: TeamMember[] = [
  {
    id: 1,
    image: Arogundade,
    name: 'Dr Arogundade Samsondeen',
    link: 'https://www.linkedin.com/in/drsammycratd2c/',
    align: 'right',
  },
  { id: 2, image: Alexander, name: 'Alexander Tkachev', link: 'https://www.linkedin.com/in/astkachev', align: 'left' },
  { id: 3, image: Herbert, name: 'Herbert Sterchi', link: 'https://www.linkedin.com/in/herbert92', align: 'left' },
  { id: 4, image: Timo, name: 'Timo Trippler', link: 'https://www.linkedin.com/in/timotrippler', align: 'left' },
  {
    id: 5,
    image: Alina,
    name: 'Alina Rosavytska',
    link: 'https://www.linkedin.com/in/blockchain-advisor-54a252a2/',
    align: 'right',
  },
  {
    id: 7,
    image: Maryna,
    name: 'Maryna Miakenka',
    link: 'https://www.linkedin.com/in/marina-myakenkaya/',
    align: 'left',
  },
];
